var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileChange}}),_c('button',{on:{"click":_vm.upload}},[_vm._v("上传")])])
}
var staticRenderFns = []

export { render, staticRenderFns }